var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2053",
    "data-name": "Grupo 2053",
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 216,
    viewBox: "0 0 220 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2421",
    "data-name": "Rect\\xE1ngulo 2421",
    width: 220,
    height: 216,
    rx: 6,
    fill: "#f9f9f9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_278_1",
    "data-name": "Componente 278 \\u2013 1",
    transform: "translate(42 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1997",
    "data-name": "Grupo 1997"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2577",
    "data-name": "Rect\\xE1ngulo 2577",
    width: 137,
    height: 137,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_18",
    "data-name": "Sustracci\\xF3n 18",
    d: "M102.75,85.625H11.417A11.45,11.45,0,0,1,0,74.209V11.417A11.45,11.45,0,0,1,11.417,0H102.75a11.45,11.45,0,0,1,11.417,11.417V74.209A11.45,11.45,0,0,1,102.75,85.625ZM88.612,50.694a27.322,27.322,0,0,0-4.453.394,17.836,17.836,0,0,1,2.482,9.025v6.345h17.735V60.271a7.947,7.947,0,0,0-4.808-7.291A27.294,27.294,0,0,0,88.612,50.694ZM57.084,45.769a40.909,40.909,0,0,0-16.71,3.586,11.675,11.675,0,0,0-6.936,10.76v6.345H80.73V60.074a11.755,11.755,0,0,0-6.936-10.759A41.6,41.6,0,0,0,57.084,45.769ZM25.556,50.694A27.3,27.3,0,0,0,14.6,52.98a7.947,7.947,0,0,0-4.808,7.291v6.188H27.527V60.114a17.827,17.827,0,0,1,2.483-9.025A27.341,27.341,0,0,0,25.556,50.694Zm63.056-19.7a7.882,7.882,0,1,0,7.882,7.882A7.891,7.891,0,0,0,88.612,30.99Zm-63.056,0a7.882,7.882,0,1,0,7.881,7.882A7.891,7.891,0,0,0,25.556,30.99ZM57.084,19.166A11.823,11.823,0,1,0,68.907,30.99,11.837,11.837,0,0,0,57.084,19.166Z",
    transform: "translate(11.416 28.542)",
    fill: "#d96e82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo);
export default __webpack_public_path__ + "static/media/grupo.0b5e73ac4e0b31658cefa11df2adcbd0.svg";
export { ForwardRef as ReactComponent };